<template>
    <div>
        <slot name="default" :buildHiddenData="buildHiddenData" :dataElm="dataElm" :ignoredData="ignoredData"></slot>

        <!--<template v-for="({name, value}) in dataElm">
            <template v-if="!ignoredData.includes(index)">
                {{name}} => {{value}} |
            </template>
            <input type="hidden" :name="name" :value="value" v-if="!ignoredData.includes(name)">
        </template>-->
    </div>
</template>

<script>
    export default {
        props: {
            ignoredData: {
                type: Array,
                default: () => []
            },
            targetSelector:{
                type: String,
                default: '.filter-search'
            }
        },
        data() {
            return {
                dataElm: {}
            };
        },
        mounted() {
            this.$root.$on('updateDataHidden', ({key, data}) => {
                console.log(key, data);
                this.updateDataHidden(key, data);
            });
        },
        methods: {

            updateDataHidden(key, data) {
                this.dataElm[key] = data;
                this.$forceUpdate();
            },
            buildHiddenData(evt) {
                /*if( evt && evt.prevendDefault ) {
                    evt.preventDefault();
                }*/
                this.$root.$emit('pageLoading', { showLoading:true, message:'' });

                let container = $(this.targetSelector),
                    formVisible = null;
                if(container.length == 0) return true;
                container.each(index => {
                    if(container.eq(index).is(":visible")){
                        formVisible = container.eq(index);
                    }
                });
                if(!formVisible || formVisible.find('input').length == 0) return true;
                this.dataElm = formVisible.find('input').serializeArray();
                return true;
            }
        }
    }
</script>
